import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import createMultiTabState from 'vuex-multi-tab-state'
import cachePlugin from '@/store/plugins/cache'
import domainCachePlugin from '@/store/plugins/domain_cache'

import SslStore from './modules/ssl/ssl'
import DomainStore from './modules/domains/domains'
import HostingStore from './modules/hosting/hosting'
import SupportStore from './modules/support/support'
import SessionStore from './modules/session/session'
import ProfileStore from './modules/profile/profile'
import BillingStore from './modules/billing/billing'
import MysqlStore from './modules/mysql/mysql'
import EmailStore from './modules/email/email'
import EmailHubStore from './modules/email/emailHub'
import SpamFiltersStore from './modules/email/spamFilters'
import EmailDeliverabilityStore from './modules/email/emailDeliverability'
import CronStore from './modules/cron/cron'
import FtpStore from './modules/ftp/ftp'
// import SslTlsStore from './modules/ssltls/ssltls'
import HostingDomainStore from './modules/hostingdomain/hostingdomain'
import HostingSshStore from './modules/hostingssh/hostingssh'
import SettingsStore from './modules/settings/settings'
import GDPRStore from './modules/gdpr/gdpr'
import CancellationsStore from './modules/cancellations/cancellations'
import PromoStore from './modules/promo/promo'
import WizardStore from './modules/wizard/wizard'
import WizardStoreModel from './modules/wizard/wizard_model'
import IdleStore from './modules/idle/idle'
import AffiliatesStore from './modules/affiliates/affiliates'
import ProtectedUrlsStore from './modules/protected_urls'
import HostingSecurityStore from './modules/hostingsecurity/hosting-security'
import NotificationsStore from './modules/notifications/notifications'
import HostingStatsStore from './modules/hostingstats/hostingstats'
import HostingPhpStore from './modules/php/php'
import HostingGitStore from './modules/git/git'
import HostingWordpressStore from './modules/wordpress/wordpress'
import HostingWpInstallStore from './modules/wordpress/wp-install'
import DowntimeStore from './modules/downtime/downtime'
import UpdowngradeStore from './modules/updowngrade/updowngrade'
import SecurityStore from './modules/security/security'
import SslManagerStore from './modules/hosting/ssl_manager/ssl_manager'
import MigrationsStore from './modules/migrations/migrations'
import AutorenewStore from './modules/autorenew/autorenew'
import WebsitesStore from './modules/websites/websites'
import SurveyStore from './modules/survey/survey'
import AppInstallerStore from './modules/installer'
import ProductsStore from './modules/products/products'
import HostingSitebuilderStore from './modules/hostingsitebuilder/hostingsitebuilder'
import RenewStore from './modules/renew/renew'

Vue.use(Vuex)

const persistedOption = {
  paths: ['domain', 'email', 'support.tickets', 'support.ticketsPopulated', 'session']
}

const createMultiTabStateOptions = {
  statesPaths: ['idle'],
}

export const store = new Vuex.Store({
  modules: {
    domain: DomainStore,
    hosting: HostingStore,
    session: SessionStore,
    support: SupportStore,
    ssl: SslStore,
    profile: ProfileStore,
    mysql: MysqlStore,
    email: EmailStore,
    emailHub: EmailHubStore,
    spam_filters: SpamFiltersStore,
    email_deliverability: EmailDeliverabilityStore,
    cron: CronStore,
    ftp: FtpStore,
    // sslTls: SslTlsStore,
    hostingDomains: HostingDomainStore,
    hostingSsh: HostingSshStore,
    settings: SettingsStore,
    gdpr: GDPRStore,
    cancellations: CancellationsStore,
    promo: PromoStore,
    wizard: WizardStore,
    wizard_model: WizardStoreModel,
    billing: BillingStore,
    idle: IdleStore,
    affiliates: AffiliatesStore,
    protected_urls: ProtectedUrlsStore,
    notifications: NotificationsStore,
    hosting_security: HostingSecurityStore,
    hosting_stats: HostingStatsStore,
    hosting_php: HostingPhpStore,
    hosting_git: HostingGitStore,
    hosting_wp: HostingWordpressStore,
    hosting_wp_install: HostingWpInstallStore,
    downtime: DowntimeStore,
    updowngrade: UpdowngradeStore,
    security: SecurityStore,
    auto_ssl_manager: SslManagerStore,
    migrations: MigrationsStore,
    autorenew: AutorenewStore,
    websites: WebsitesStore,
    survey: SurveyStore,
    app_installer: AppInstallerStore,
    products: ProductsStore,
    hostingsitebuilder: HostingSitebuilderStore,
    renew: RenewStore,
  },
  plugins: [
    createPersistedState(persistedOption),
    cachePlugin,
    domainCachePlugin,
    createMultiTabState(createMultiTabStateOptions)
  ],
  strict: process.env.NODE_ENV !== 'production'
})
